import React from 'react';
import ErrorNetwork from 'components/Error/ErrorNetwork';
import { withLocale } from '@dietlabs/components';

const ErrorNetworkContainer = props => <ErrorNetwork topLevel {...props} />;

export default withLocale(ErrorNetworkContainer);
